import { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useAPI } from 'global'
import { apiError } from 'utils'
import { Button, TextField } from 'components'
import './styles.scss'

export default function ApplyDeviceConfigButton(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const { config, device, commandString, ...btnProps } = props
  const [showDurationInput, setShowDurationInput] = useState()
  const defaultDuration = 60
  const durationMinutes = useRef(defaultDuration)
  const api = useAPI()

  if (!config) return <></>

  const onClick = () => {
    if (commandString == t('commands.stayUnlocked'))
      setShowDurationInput(!showDurationInput)
    if (commandString == t('commands.merchandize')) {
      setShowDurationInput(false)
      applyDeviceConfig()
    }
  }

  const applyDeviceConfig = () => {
    if (commandString == t('commands.stayUnlocked') && (!durationMinutes.current?.value || (durationMinutes.current?.value && (durationMinutes.current.value < 1 || durationMinutes.current.value > 1440)))) {
      toast.error(t('error.stayUnlockedDuration'))
      return
    }
    api.applyDeviceConfig({
      storeId: config.storeId,
      configurationTypeId: config.id,
      securityDeviceId: device?.id,
      durationMinutes: Number(durationMinutes.current.value) || defaultDuration,
    }).then(() => {
      toast.success(t('commands.commandSent', { cmd: commandString }))
      setShowDurationInput(false)
    }).catch(apiError)
  }

  return (
    <div className='col apply-device-config-button-comp'>
      {!showDurationInput &&<Button {...btnProps} onClick={onClick}>{commandString}</Button>}
      {showDurationInput &&
        <div className='col duration-section'>
          <TextField label={t('deviceConfig.stayUnlockedDur')} ref={durationMinutes} type='number' min={1} max={1440} defaultValue={defaultDuration} />
          <div className='row button-row'>
            <Button outline onClick={()=>setShowDurationInput(false)}>{t('form.cancel')}</Button>
            <Button onClick={applyDeviceConfig}>{t('form.save')}</Button>
          </div>
        </div>
      }
    </div>
  )
}
